import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getSpecies(pageSize: number) {
  try {
    const resp = await axios.get(`/api/species/?pageSize=${pageSize}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function searchSpecies(query: object) {
  let searchQuery = getQueryString(query);
  try {
    const resp = await axios.get("/api/species/search?" + searchQuery);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createSpecies(species: object) {
  try {
    const resp = await axios.put("/api/species/Create/", species);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateSpecies(species: object) {
  try {
    const resp = await axios.post("/api/species/update/", species);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteSpecies(species_id: string) {
  try {
    const resp = await axios.delete("/api/species/delete?id=" + species_id);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getSpeciesById(species_id: string) {
  try {
    const resp = await axios.get("/api/species/" + species_id + "/details");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
